import {BaseEvent} from "./BaseEvent";

export class ChangePartitionEvent extends BaseEvent {
  public static NAME = 'ChangePartitionEvent';

  constructor() {
    super(ChangePartitionEvent.NAME);
  }
}
